import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  getFactoryByGroupID,
  getFuelTypesForDropdown,
  getJobTypesForDropdown,
  GetGradeByGradeCategoryID,
  GetManufactureDetailsToManufactureScreen,
  GetManufactureTypes,
  SaveNewManufacture,
  GetManufactureDetailsByManufacturingID,
  UpdateNewManufacture,
  GetGreenLeafQuantityForManufacture,
  GetRefuseTeaQuantityForManufacture,
  GetWarehouseDetailsByFactoryID,
  GetAllGradeCategory,
  ApproveManufactureDetails,
  RejectManufactureDetails,
  GetBaughtLeafDeductionQtyForUpdate,
  GetWitheredLeafQtyForUpdate
};

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + parseInt(groupID))
  return response.data;
}

async function getFuelTypesForDropdown(factoryID) {
  var fuelTypeArray = [];
  const response = await CommonGet('/api/Manufacturing/GetAllFuelTypesByFactoryID', "factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    fuelTypeArray[item[1]["fuelTypeID"]] = {
      name: item[1]["fuelName"],
      unit: item[1]["unit"].trim()
    };
  }
  return fuelTypeArray;
}

async function getJobTypesForDropdown() {
  var jobTypeArray = [];
  const response = await CommonGet('/api/Manufacturing/GetAllJobTypes', null)
  for (let item of Object.entries(response.data)) {
    jobTypeArray[item[1]["jobTypeID"]] = item[1]["jobTypeName"]
  }
  return jobTypeArray;
}

async function GetAllGradeCategory() {
  const response = await CommonGet('/api/NewManufacturing/GetAllGradeCategory', null);
  return response.data;
}

async function GetGradeByGradeCategoryID(gradeCategoryID) {
  const response = await CommonGet('/api/NewManufacturing/GetGradeByGradeCategoryID', "gradeCategoryID=" + parseInt(gradeCategoryID));
  return response.data;
}

async function GetManufactureDetailsToManufactureScreen(groupID, factoryID, fromDate, toDate, statusID) {
  let model = {
    groupID: parseInt(groupID),
    factoryID: parseInt(factoryID),
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
    statusID: parseInt(statusID)
  }
  const response = await CommonPost('/api/NewManufacturing/GetManufactureDetailsToManufactureScreen', null, model);
  return response.data;
}

async function GetManufactureTypes(operationEntityID) {
  const response = await CommonGet('/api/NewManufacturing/GetManufactureTypes', "operationEntityID=" + parseInt(operationEntityID));
  return response.data;
}

async function SaveNewManufacture(model) {
  const response = await CommonPost('/api/NewManufacturing/SaveNewManufacture', null, model);
  return response;
}

async function GetManufactureDetailsByManufacturingID(manufacturingID) {
  const response = await CommonGet('/api/NewManufacturing/GetManufactureDetailsByManufacturingID', "manufacturingID=" + parseInt(manufacturingID));
  return response.data;
}

async function UpdateNewManufacture(model) {
  const response = await CommonPost('/api/NewManufacturing/UpdateNewManufacture', null, model);
  return response;
}

async function GetGreenLeafQuantityForManufacture(factoryID, fromDateOfCrop, toDateOfCrop) {
  const response = await CommonGet('/api/NewManufacturing/GetGreenLeafQuantityForManufacture', "operationEntityID=" + parseInt(factoryID) + "&fromDateOfCrop=" + fromDateOfCrop + "&toDateOfCrop=" + toDateOfCrop);
  return response.data;
}

async function GetRefuseTeaQuantityForManufacture(factoryID, fromDateOfCrop, toDateOfCrop) {
  const response = await CommonGet('/api/NewManufacturing/GetRefuseTeaQuantityForManufacture', "operationEntityID=" + parseInt(factoryID) + "&fromDateOfCrop=" + fromDateOfCrop + "&toDateOfCrop=" + toDateOfCrop);
  return response.data;
}

async function GetWarehouseDetailsByFactoryID(factoryID) {
  const response = await CommonGet('/api/NewManufacturing/GetWarehouseDetailsByFactoryID', "factoryID=" + parseInt(factoryID));
  return response.data;
}

async function ApproveManufactureDetails(model) {
  const response = await CommonPost('/api/NewManufacturing/ApproveManufactureDetails', null, model);
  return response;
}

async function RejectManufactureDetails(model) {
  const response = await CommonPost('/api/NewManufacturing/RejectManufactureDetails', null, model);
  return response;
}

async function GetBaughtLeafDeductionQtyForUpdate(manufacturingID){
  const response = await CommonGet('/api/NewManufacturing/GetBaughtLeafDeductionQtyForUpdate', "manufacturingID=" + parseInt(manufacturingID));
  return response.data;
}

async function GetWitheredLeafQtyForUpdate(manufacturingID){
  const response = await CommonGet('/api/NewManufacturing/GetWitheredLeafQtyForUpdate', "manufacturingID=" + parseInt(manufacturingID));
  return response.data;
}